import { useField, ValidationResult } from 'vee-validate';
import { MaybeRefOrGetter, ref, toRef } from 'vue';

export function useValidateFieldErrorMessage(name: MaybeRefOrGetter<string>) {
  const path = toRef(name);

  const validationResult = ref<ValidationResult>();

  const { validate: validateField, errorMessage } = useField(path);

  async function validate() {
    validationResult.value = await validateField();
  }

  return {
    validate,
    errorMessage,
    validationResult,
  };
}
